export const dateFormat = (date = new Date()) => {
  const year = new Intl.DateTimeFormat('default', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
    .format(date)
    .split('/')
    .reverse()
    .join('-');

  const time = new Intl.DateTimeFormat('default', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);

  // YYYY-MM-DD HH:mm
  return `${year} ${time}`;
};
